import { buildAppUrl } from '@/vue/utils/urlBuilder'

/**
 * Construye una URL absoluta hacia una ruta web de la aplicación.
 *
 * Añade el prefijo `/web` fuera de Docker y conserva la raíz en Docker.
 *
 * @param path - Ruta web relativa, con o sin barra inicial.
 * @returns URL absoluta correspondiente a la ruta solicitada.
 */
export function webURL(path: string): string {
    const basePath = import.meta.env.VITE_ENTORNO_DOCKER === 'true' ? '' : 'web'

    return buildAppUrl(path, basePath)
}
